export default __webpack_public_path__ + "images/0x98878b06940ae243284ca214f92bb71a2b032b8a.png";